import React from 'react';
import dayjs from 'dayjs';
import { Col, Form, Layout, Row, Typography } from 'antd';
import { Input, InputPhone, Select } from 'components';
import { useLang } from '../PlayerRegistration';
import { CONTACT_RELATION_OPTIONS } from './constants';
import './style.scss';

const isUnder18 = (birthDate: any): boolean => {
  if (!birthDate) return false;
  const today = dayjs();
  const age = today.diff(birthDate, 'year');
  return age < 18;
};

export const Step7 = () => {
  const { t } = useLang();

  return (
    <Layout className="player-registration__step-7">
      <Form.Item shouldUpdate={(prev, curr) => prev.birthdate !== curr.birthdate} noStyle>
        {({ getFieldValue }) => {
          const less18 = isUnder18(getFieldValue('birthdate'));
          if (!less18) return null;

          return (
            <div className="guardian-block">
              <Row className="step-header">
                <Col span={24}>
                  <Typography.Title level={4}>{t('subtitle_step_7')}</Typography.Title>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col span={24} md={{ span: 12 }}>
                  <Input
                    name="guardian_first_name"
                    label={t('label_first_name')}
                    maxLength={20}
                    rules={[{ required: true, message: t('error_first_name') }]}
                  />
                </Col>
                <Col span={24} md={{ span: 12 }}>
                  <Input
                    name="guardian_last_name"
                    label={t('label_last_name')}
                    maxLength={20}
                    rules={[{ required: true, message: t('error_last_name') }]}
                  />
                </Col>
              </Row>
              <Row gutter={8}>
                <Col flex="1">
                  <Input
                    label={t('label_email')}
                    name="guardian_email"
                    rules={[
                      { required: true, message: t('error_email') },
                      { type: 'email', message: t('error_email_format') },
                      {
                        validator(_, value) {
                          if (value && value === getFieldValue('email')) {
                            return Promise.reject(new Error(t('error_guardian_email')));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    formItemProps={{
                      normalize: (value) => value.replace(/[^a-zA-Z0-9@._%+-]/g, ''),
                    }}
                  />
                </Col>
                <Col flex="168px">
                  <InputPhone
                    name="guardian_phone"
                    label={t('label_phone')}
                    rules={[
                      { required: true, message: t('error_phone') },
                      {
                        pattern: /^\D*(\d\D*){10}$/,
                        message: t('error_phone_format'),
                      },
                    ]}
                  />
                </Col>
              </Row>
            </div>
          );
        }}
      </Form.Item>

      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_7_1')}</Typography.Title>
        </Col>
      </Row>
      <Form.Item shouldUpdate={(prev, curr) => prev.birthdate !== curr.birthdate} noStyle>
        {({ getFieldValue }) => {
          const less18 = isUnder18(getFieldValue('birthdate'));

          return (
            <Row gutter={8}>
              <Col span={12}>
                <Input
                  name="emergency_contact_first_name"
                  label={t('label_emergency_first_name')}
                  rules={[{ required: less18, message: t('error_emergency_first_name') }]}
                />
              </Col>
              <Col span={12}>
                <Input
                  name="emergency_contact_last_name"
                  label={t('label_emergency_last_name')}
                  rules={[{ required: less18, message: t('error_last_name') }]}
                />
              </Col>
              <Col flex="1">
                <Select
                  name="emergency_contact_relation"
                  label={t('label_emergency_contact_relation')}
                  options={CONTACT_RELATION_OPTIONS}
                  rules={[{ required: less18, message: t('error_contact_relation') }]}
                />
              </Col>
              <Col flex="168px">
                <InputPhone
                  name="emergency_contact_phone"
                  label={t('label_emergency_mobile_phone')}
                  rules={[
                    { required: less18, message: t('error_phone') },
                    {
                      pattern: /^\D*(\d\D*){10}$/,
                      message: t('error_phone_format'),
                    },
                  ]}
                />
              </Col>
            </Row>
          );
        }}
      </Form.Item>
    </Layout>
  );
};
